var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Duplicate",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M46.74,26.26H36.42V18.57a1.26,1.26,0,0,0-1.26-1.26H17.26A1.26,1.26,0,0,0,16,18.57v17.9a1.26,1.26,0,0,0,1.26,1.26H27.58v7.69a1.26,1.26,0,0,0,1.26,1.26h17.9A1.26,1.26,0,0,0,48,45.43V27.53A1.26,1.26,0,0,0,46.74,26.26ZM18.52,35.21V19.84H33.9v6.43H28.84a1.26,1.26,0,0,0-1.26,1.26v7.69ZM33.9,28.79v6.42H30.1V28.79ZM45.48,44.16H30.1V37.74h5.06a1.26,1.26,0,0,0,1.26-1.26V28.79h9.05Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/duplicate.svg